/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
import "firebase/compat/functions";
/* eslint-enable no-restricted-imports */
import useSWRImmutable from "swr/immutable";

import type {
  GetCapsuleBoxRequest,
  GetCapsuleBoxResponse,
} from "@spwn/types/functions";
import type { CapsuleBoxDTO } from "@spwn/types/functions/capsuleBox";

export const useGetCapsuleBox = ({
  eventId,
  capsuleId,
}: {
  eventId: string;
  capsuleId: number;
}): {
  capsuleBox: CapsuleBoxDTO;
  isLoading: boolean;
  error: unknown;
} => {
  const { data, error, isLoading } = useSWRImmutable(
    ["getCapsuleBox", eventId, capsuleId],
    async () => {
      const { data } = await callGetCapsuleBox({
        eventId,
        capsuleId,
      });
      return data;
    }
  );

  return {
    // @ts-expect-error TS2322
    capsuleBox: data,
    isLoading,
    error,
  };
};

const callGetCapsuleBox = async (
  request: GetCapsuleBoxRequest
): Promise<{ data: GetCapsuleBoxResponse }> => {
  return await firebase.functions().httpsCallable("getCapsuleBox")(request);
};
